import { render } from "./control-sidebar.html?vue&type=template&id=51735720&ts=true&external"
import script from "./control-sidebar.ts?vue&type=script&lang=ts&external"
export * from "./control-sidebar.ts?vue&type=script&lang=ts&external"

import "./control-sidebar.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__